<div class="row" *ngIf="showCallAction">
  <div class="col-12 col-md-6">
    <ngx-call-action-card title="Hire us to customize ngx-admin"
                          type="pantone"
                          link="https://www.akveo.com/contact?utm_campaign=services%20-%20ngx_admin%20customization%20-%20ngx_admin%20demo%20dashboard&utm_source=ngx_admin&utm_medium=referral&utm_content=ecom_dashboard_demo"
                          linkTitle="Contact us">
    </ngx-call-action-card>
  </div>
  <div class="col-12 col-md-6">
    <ngx-call-action-card title="Documentation and customization articles"
                          type="briefcase"
                          link="https://akveo.github.io/ngx-admin?utm_campaign=ngx_admin%20-%20landing%20-%20ngx_admin%20demo&utm_source=ngx_admin&utm_medium=referral&utm_content=ecom_docs_panel"
                          linkTitle="Learn more">
    </ngx-call-action-card>
  </div>
</div>
<div class="row">
  <div class="col-xxl-5">
    <div class="row">
      <div class="col-md-6">
        <ngx-profit-card></ngx-profit-card>
      </div>
      <div class="col-md-6">
        <ngx-earning-card></ngx-earning-card>
      </div>
    </div>

    <ngx-traffic-reveal-card></ngx-traffic-reveal-card>
  </div>

  <div class="col-xxl-7">
    <ngx-ecommerce-charts></ngx-ecommerce-charts>
  </div>
</div>

<div class="row">
  <div class="col-xxl-9">
    <ngx-country-orders></ngx-country-orders>
  </div>

  <div class="col-xxl-3">
    <ngx-progress-section></ngx-progress-section>
  </div>
</div>

<div class="row">
  <div class="col-xxl-9">
    <ngx-ecommerce-visitors-analytics></ngx-ecommerce-visitors-analytics>
  </div>

  <div class="col-xxl-3">
    <ngx-user-activity></ngx-user-activity>
  </div>
</div>
